module.exports = __webpack_public_path__ + "img/c-1.5fe065dd.png";